import { render, staticRenderFns } from "./NonConformityActionCard.vue?vue&type=template&id=442b90f1&scoped=true&"
import script from "./NonConformityActionCard.vue?vue&type=script&lang=js&"
export * from "./NonConformityActionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442b90f1",
  null
  
)

export default component.exports